export default __webpack_public_path__ + "img/fpYUAqiH.c1652270.svg";